import React from 'react';

import { LoadableLazy } from '@confluence/loadable';

import { useIsStorageEnforcementEligible } from '../../hooks/useIsStorageEnforcementEligible.ts';

const BlockCreateModalLoadable = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-BlockCreateModalLoadable" */ './BlockCreateModal.tsx'
			)
		).BlockCreateModal,
});

export const BlockCreateModal = (): React.JSX.Element | null => {
	const isEligibleUser = useIsStorageEnforcementEligible();
	return isEligibleUser ? <BlockCreateModalLoadable /> : null;
};
